import { PageContent } from "@/shared/widgets/layout/PageContent";
import { useNavigate } from "react-router-dom";
import { Button } from "@/shared/ui/button";
import { PlusIcon } from "lucide-react";
import LearningList from "./LearningList";
import { useTranslation } from "@/shared/i18n";

const LearningsIndex = () => {
    const { t } = useTranslation('learnings');
    const navigate = useNavigate();

    const createButton = (
        <Button onClick={() => navigate("/learning/new")}>
            <PlusIcon className="h-4 w-4 mr-2" />
            {t('newLearning')}
        </Button>
    );

    return (
        <PageContent
            title={t('learnings')}
            items={[
                {
                    label: t('home'),
                    href: "/",
                },
                {
                    label: t('learnings'),
                    href: "/learning",
                },
            ]}
            actions={createButton}
        >
            <div className="rounded-lg overflow-hidden ">
                <LearningList />
            </div>
        </PageContent>
    );
};

export default LearningsIndex;